import Vue from 'vue'
import Router from 'vue-router'
const about = () => import('@//views/about/index')
const Home = () => import('@//views/Home/index')
const business = () => import('@/views/business/index')
const introduce = () => import('@/views/introduce/index')
const information = () => import('@/views/information/index')
const statement = () => import('@/views/statement/index')
Vue.use(Router)

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home
  },
  // 关于我们
  {
    path: '/about',
    name: 'about',
    component: about
  },
  {
    path: '/business',
    name: 'business',
    component: business
  },
  // 项目介绍
  {
    path: '/introduce',
    name: 'introduce',
    component: introduce
  },
  {
    path: '/information',
    name: 'information',
    component: information
  },
  {
    path: '/statement',
    name: 'statement',
    component: statement
  }
]
const router = new Router({
  routes
})
export default router



// WEBPACK FOOTER //
// ./src/router/index.js